import Box from '@mui/material/Box';
import PollIcon from '@mui/icons-material/Poll';
import {pink} from '@mui/material/colors';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SelectAccountModal from '../components/SelectAccountModal';
import image1 from '../static/images/iChooseapp-logos/iChooseapp-logos_black.png';


export default function SignInPage() {
  return <>
    <Box sx={{height: window.screen.height}}>
      <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', mr: 1, ml: 1}}>
        <Stack>
          <div style={{textAlign: 'center'}}>
            <Typography variant={'h5'}> Poll time</Typography>
            <PollIcon fontSize={'large'} sx={{color: pink[500], fontSize: 100}}/>

          </div>
          <SelectAccountModal/>
          <Box sx={{mt: 2}}>
            {/*<FormGroup>*/}
            {/*    <FormControlLabel control={<Checkbox defaultChecked/>} label={*/}
            {/*        <>*/}
            {/*            <Typography gutterBottom={true}>*/}
            {/*                By clicking login you agree to our <a href={'https://example.com/'}>terms and conditions</a>.*/}
            {/*                Learn how we process your data in  <a href={'https://example.com/'}>our Privacy policy</a>*/}
            {/*            </Typography>*/}
            {/*        </>*/}
            {/*    }/>*/}
            {/*</FormGroup>*/}
            <Typography gutterBottom={true}>
              By clicking login you agree to our <a href={'https://example.com/'}>terms and conditions</a>.
              Learn how we process your data in <a href={'https://example.com/'}>our Privacy policy</a>
            </Typography>
          </Box>
          <Box sx={{textAlign: 'center', mt: 10}}>
            <img src={image1} width={200} height={40} alt={'Parent App Logo'}/>
          </Box>
        </Stack>
      </Box>

    </Box>
  </>
}
